import { TourneeFilter } from '../../tournee/models/tournee-filter.model';
import { CommissionFilter } from './commission-filter.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class EchantillonFilterExport {
    static jsonMap = {
        millesimes: { key: 'millesimes', default: () => [] },
        tournees: { key: 'tournees', converter: new (ArrayClassConverterFactory.build(TourneeFilter))(), default: () => [] },
        commissions: { key: 'commissions', converter: new (ArrayClassConverterFactory.build(CommissionFilter))(), default: () => [] }
    };

    millesimes: number[];
    tournees: TourneeFilter[];
    commissions: CommissionFilter[];
}
